<template>
  <div class="h-100 pt-4">
    <v-overlay
      v-model="inProgress"
      scrim="#9d9a99"
      persistent
      contained
      class="align-center justify-center"
    >
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-progress-circular
              indeterminate
              size="80"
              color="primary"
              align="center"
              justify="center"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
    <ProductPageHeader
      v-if="isMobileDevice"
      :undoRedoImages="{ redoInactive, redoActive, undoActive, undoInactive }"
    />
    <v-container fluid class="white pt-2 h-100 pb-1" v-resize="resize">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="7"
          class="pb-1 pt-1 overflow-sm-hidden"
          v-if="!isMobileDevice"
        >
          <v-col
            cols="12"
            class="py-0 d-flex justify-space-between align-center"
          >
            <v-img
              :src="craneLogoBlue"
              class="cursor-pointer"
              @click="goToHomePage()"
              max-width="100"
              max-height="42"
              aspect-ratio="1"
              contain
            ></v-img>
          </v-col>
          <v-row class="h-100">
            <v-row
              v-if="thumbnailInProgress"
              class="mx-sm-4 align-center justify-center"
            >
              <v-col cols="12" sm="6" md="6" class="text-center">
                <v-progress-circular
                  indeterminate
                  size="80"
                  color="primary"
                  align="center"
                  justify="center"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-container v-else class="pb-0 pt-7">
              <v-row
                class="mx-sm-4 align-start overflow"
                :style="'height:' + thumbnailDivHeight + 'px'"
              >
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  v-for="(part, index) in productParts"
                  :key="index"
                  class=""
                >
                  <div class="summary-border pa-3">
                    <template v-if="part.thumbnailUrls">
                      <v-row>
                        <v-col
                          v-for="partThumb in part.thumbnailUrls"
                          :key="partThumb?.surface"
                          :cols="12 / Object.keys(part.thumbnailUrls).length"
                          class="d-block pa-3"
                        >
                          <v-img
                            :src="
                              partThumb?.thumbnailUrl
                                ? partThumb?.thumbnailUrl
                                : defaultUrl
                            "
                            :lazy-src="defaultUrl"
                            height="auto"
                            @click="
                              goToBuilder(partThumb.id, part.userSelected)
                            "
                            class="cursor-pointer"
                          >
                            <div class="text-right" v-if="part.partModified">
                              <v-icon icon class="text-primary"
                                >mdi-check</v-icon
                              >
                            </div>
                            <div
                              class="text-right mt-n1 mr-n1"
                              v-if="!part.userSelected"
                            >
                              <v-icon icon class="img-square-color"
                                >mdi-square</v-icon
                              >
                            </div>
                          </v-img>
                          <p
                            class="text-primary pt-2 mb-0 body-font fontsize-12 text-uppercase text-center"
                          >
                            {{ part.name }} ({{
                              getCurrentPartSurface(partThumb?.surface)
                            }})
                          </p>
                        </v-col>
                      </v-row>
                    </template>
                  </div>
                </v-col>
              </v-row>
              <!-- <v-col
                cols="12"
                sm="12"
                md="12"
                class="pt-8 d-sm-block d-none"
                v-if="projectDetails"
              >
                <p class=" ">
                  {{ projectDetails.version }}
                </p>
              </v-col> -->
            </v-container>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="5"
          ref="sideBar"
          class="pt-0 pb-1 d-block block-column overflow-sm-hidden"
        >
          <v-row class="d-block align-center px-3">
            <v-row class="pb-1 d-flex align-center" v-if="!isMobileDevice">
              <v-col cols="6" :class="designerFlag ? 'py-3' : 'pt-1'">
                <p
                  class="text-uppercase fontsize-16 body ls-n01 text-primary mb-0 text-truncate"
                >
                  Review Your Order
                </p>
              </v-col>
              <v-col class="text-right pt-2" cols="6">
                <ProductPageHeader
                  v-if="!isMobileDevice"
                  :undoRedoImages="{
                    redoInactive,
                    redoActive,
                    undoActive,
                    undoInactive,
                  }"
                />
              </v-col>
            </v-row>
            <v-card
              tile
              flat
              outlined
              class="productpage-stylebar-border mt-3 overflow"
              :style="'height:' + designWindowHeight + 'px'"
            >
              <v-card-text class="h-100">
                <v-row no-gutters>
                  <v-col class>
                    <p class="text-uppercase text-primary mb-0 float-left">
                      Design
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <p
                      class="text-uppercase fontsize-18 regular-font text-primary mb-0 float-right"
                    >
                      {{ productDetails.name }}
                    </p>
                  </v-col>
                </v-row>
                <div
                  color="text-primary"
                  class="mx-n4 productpage-hr-line my-3"
                ></div>
                <v-row
                  v-if="summaryDetailsInProgress"
                  class="align-center justify-center h-100"
                >
                  <v-progress-circular
                    indeterminate
                    size="80"
                    color="primary"
                    align="center"
                    justify="center"
                  ></v-progress-circular>
                </v-row>
                <template v-else>
                  <div
                    class
                    v-for="(part, index) in productSummaryDetails"
                    :key="index"
                  >
                    <v-row class="mt-3">
                      <!-- v-if="part.partSelected" -->

                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="4" class="">
                            <span
                              class="text-uppercase text-primary d-block text-truncate mb-0 float-left"
                              >{{ part.name }}</span
                            >
                          </v-col>
                        </v-row>
                        <template
                          v-for="(obj, idx) of part.combinedElements"
                          :key="idx"
                        >
                          <v-row no-gutters>
                            <v-col cols="12" class="pb-3">
                              <v-row no-gutters class="mt-1">
                                <v-divider
                                  color="primary"
                                  thickness="2"
                                  opacity="1"
                                ></v-divider>
                                <v-col cols="4" class="">
                                  <span
                                    class="text-uppercase text-primary mb-0 body"
                                    >{{ getCurrentPartSurface(idx) }}</span
                                  >
                                </v-col>
                                <v-col cols="5" class=""></v-col>
                                <v-col cols="2" class=""></v-col>
                                <v-col cols="1" class=""> </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col cols="6" class="">
                                  <span
                                    class="text-uppercase text-primary d-block text-truncate mb-0 float-left"
                                    >Size</span
                                  >
                                </v-col>
                                <v-col cols="6" class="pl-1">
                                  <p class="text-uppercase text-primary mb-0">
                                    {{
                                      part.paperWidth +
                                      " X " +
                                      part.paperHeight +
                                      " inches"
                                    }}
                                  </p>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col cols="6" class="">
                                  <span
                                    class="text-uppercase text-primary d-block text-truncate mb-0 float-left"
                                    >Stock</span
                                  >
                                </v-col>
                                <v-col cols="6" class="pl-1">
                                  <p
                                    class="text-uppercase text-primary mb-0"
                                    v-if="part.paper"
                                  >
                                    {{ part.paper }}
                                  </p>
                                </v-col>
                              </v-row>

                              <template
                                v-for="(ele, eleIdx) in obj.elements"
                                :key="eleIdx"
                              >
                                <!-- {{ ele }} -- {{ hideElement(ele) }} -->
                                <v-row no-gutters v-if="!hideElement(ele)">
                                  <v-col cols="6" class="d-block text-truncate">
                                    <p
                                      v-if="ele.type === 'liner'"
                                      class="text-uppercase text-primary d-block text-truncate mb-0"
                                    >
                                      {{ ele.type }}
                                    </p>
                                    <p
                                      v-else
                                      class="text-uppercase text-primary d-block text-truncate mb-0"
                                    >
                                      {{ ele.name }}
                                    </p>
                                  </v-col>
                                  <v-col cols="6" class="pl-1">
                                    <p
                                      v-if="ele.removed"
                                      class="text-primary mb-0"
                                    >
                                      Disabled
                                    </p>
                                    <p
                                      v-else-if="ele.name === 'liner'"
                                      class="text-uppercase text-primary d-block text-truncate mb-0"
                                    >
                                      {{ ele?.value?.name }}
                                    </p>
                                    <p
                                      v-else
                                      class="text-uppercase text-primary mb-0"
                                    >
                                      {{ ele.print?.name
                                      }}{{
                                        ele.color ? " - " + ele.color.name : ""
                                      }}
                                    </p>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-col>
                          </v-row>
                        </template>
                      </v-col>
                      <v-divider color="text-primary"></v-divider>
                      <v-row
                        no-gutters
                        class="all-side-primary-border left-right-border-none mx-n1"
                      >
                        <v-col
                          cols="6"
                          class="d-flex flex-row align-center py-0 right-primary-border"
                        >
                          <v-row no-gutters>
                            <v-col
                              cols="12"
                              class="py-2 px-4 d-flex align-center text-center"
                            >
                              <p class="text-uppercase text-primary mb-0">
                                {{ productQuantity }} {{ part.name }}
                              </p>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col class="my-auto"> </v-col>
                        <v-col class="my-auto"> </v-col>
                      </v-row>
                    </v-row>
                  </div>
                  <v-row
                    no-gutters
                    v-if="addonPrice"
                    class="all-side-primary-border left-right-border-none border-top-none pa-2 mt-3 mx-n4"
                  >
                    <v-col cols="6" class="d-flex px-2 flex-row align-center">
                      <p class="text-primary">Additional Colors:</p>
                    </v-col>
                    <v-col cols="6" class="my-auto text-primary pl-1">
                      ${{ addonPrice }}
                    </v-col>
                    <v-col class="my-auto"> </v-col>
                  </v-row>
                  <v-row
                    no-gutters
                    class="all-side-primary-border left-right-border-none border-top-none border-bottom-none py-0"
                    :class="addonPrice ? '' : 'mt-3'"
                  >
                    <v-col
                      class="right-primary-border mb-n4 d-flex align-center py-2"
                      cols="6"
                    >
                      <p class="text-uppercase text-primary mb-0">Quantity :</p>
                    </v-col>
                    <v-col cols="6" class="d-flex flex-row align-center mb-n4">
                      <v-row no-gutters>
                        <v-col cols="2">
                          <v-btn
                            variant="plain"
                            :ripple="false"
                            size="x-small"
                            icon
                            :disabled="selectedIndex > 0 ? false : true"
                            class="btn-plus-minus-font"
                            :class="
                              selectedIndex > 0 ? 'btn-plus-minus-opacity' : ''
                            "
                          >
                            <v-icon
                              color="primary"
                              class="header-buttons"
                              @click="changeQuantity(selectedIndex - 1)"
                              >mdi mdi-minus</v-icon
                            >
                          </v-btn>
                        </v-col>
                        <v-col cols="8" class="d-flex align-center text-center">
                          <p class="text-uppercase text-primary ma-auto">
                            {{ productQuantity }}
                          </p>
                        </v-col>
                        <v-col cols="2">
                          <v-btn
                            variant="plain"
                            :ripple="false"
                            size="x-small"
                            class="pr-2 btn-plus-minus-font"
                            :class="
                              qtyPriceArray.length == 0
                                ? ''
                                : selectedIndex == qtyPriceArray.length - 1
                                ? ''
                                : 'btn-plus-minus-opacity'
                            "
                            icon
                            :disabled="
                              qtyPriceArray.length == 0
                                ? true
                                : selectedIndex == qtyPriceArray.length - 1
                                ? true
                                : false
                            "
                          >
                            <v-icon
                              color="primary"
                              class="header-buttons"
                              @click="changeQuantity(selectedIndex + 1)"
                              >mdi mdi-plus</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>

            <v-col
              cols="12"
              ref="bottomDivTotal"
              class="pt-5 pb-0 align-end d-block block-column"
            >
              <v-row>
                <div class="mb-2 pt-2 pt-sm-0">
                  <v-checkbox
                    v-model="acceptAndApproved"
                    @change="checkAcceptAndApproved"
                    color="primary"
                    class="mt-1 ml-0 color-checkbox"
                    hide-details
                    label="I’ve reviewed all spelling, dates and other personalized information for accuracy. I acknowledge that Crane is not responsible for additional review, and that my order will be printed as shown. I approve that all my order information is correct."
                    :value="true"
                  ></v-checkbox>
                </div>
                <div class="mb-2 pt-2 pt-sm-0" v-if="printProcessMismatched">
                  <v-checkbox
                    v-model="printProcessGranted"
                    @change="checkMismatchPrintProcess"
                    color="primary"
                    class="mt-1 ml-0 color-checkbox"
                    hide-details
                    label="your order includes items that use different printing processes. this may affect your order price or processing time. if you intended this, then you're all  set. please check the box to proceed. if this selection was unitentional, just use the edit design button below to change your selection."
                    :value="true"
                  ></v-checkbox>
                </div>
              </v-row>
              <v-row class="d-block justify-end align-end px-3">
                <v-row>
                  <v-col v-if="isPromotionApplied" cols="12" v-resize="resize">
                    <div class="d-flex justify-space-between">
                      <h3 class="text-uppercase text-primary mb-0">subtotal</h3>
                      <h3 class="text-uppercase text-primary mb-0">
                        <span
                          :class="
                            isPromotionApplied
                              ? 'text-decoration-line-through text-black text-disabled'
                              : ''
                          "
                          class=""
                          >${{ priceFormatter(originalSubTotal) }}</span
                        >
                      </h3>
                    </div>
                    <div class="d-flex justify-space-between">
                      <span class="text-uppercase text-primary">{{
                        appliedPromotion?.name
                      }}</span>
                      <h3 class="text-uppercase text-primary">
                        <v-icon
                          color="primary"
                          v-if="isPromotionApplied"
                          class="header-buttons"
                          >mdi-sale</v-icon
                        >
                        ${{ priceFormatter(subTotal) }}
                      </h3>
                    </div>
                  </v-col>
                  <v-col
                    v-else
                    cols="12"
                    class="d-flex justify-space-between py-1"
                  >
                    <h3 class="text-uppercase text-primary mb-0">subtotal</h3>
                    <h3 class="text-uppercase text-primary mb-0">
                      ${{ priceFormatter(subTotal) }}
                    </h3>
                  </v-col>
                </v-row>
                <v-row class="d-flex align-end justify-end mt-2 pb-3">
                  <v-col cols="6" lg="3" class="py-0 px-1">
                    <v-btn
                      block
                      :size="
                        this.$vuetify.display.mdAndUp ? 'x-large' : 'default'
                      "
                      class="text-uppercase ls-0 body px-2 rounded-0 button-text"
                      variant="outlined"
                      color="primary"
                      @click="addSaveForLater"
                      >Save For Later</v-btn
                    ></v-col
                  >
                  <!-- :disabled="
                    subTotal == 0 ||
                    acceptAndApproved == false ||
                    isErrorInPrice ||
                    disableSubmit == true
                      ? true
                      : false
                  " -->
                  <v-col cols="6" lg="3" class="py-0 px-1">
                    <v-btn
                      block
                      class="text-uppercase ls-0 body pb-1 px-2 rounded-0"
                      :size="
                        this.$vuetify.display.mdAndUp ? 'x-large' : 'default'
                      "
                      variant="outlined"
                      color="primary"
                      @click="backToEditPart()"
                      >Edit Design</v-btn
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    class="py-0 px-1"
                    v-if="!designerFlag"
                  >
                    <v-btn
                      v-if="!cartItemEdit"
                      :disabled="
                        !subTotal ||
                        acceptAndApproved == false ||
                        isErrorInPrice ||
                        disableSubmit == true
                          ? true
                          : false
                      "
                      block
                      :size="
                        this.$vuetify.display.mdAndUp ? 'x-large' : 'default'
                      "
                      class="text-uppercase ls-0 body pb-1 px-1 rounded-0 mt-2"
                      tile
                      color="primary"
                      @click="addToCart()"
                      >ADD TO CART</v-btn
                    >
                    <v-btn
                      v-if="cartItemEdit"
                      :disabled="
                        !subTotal ||
                        acceptAndApproved == false ||
                        isErrorInPrice ||
                        disableSubmit == true
                          ? true
                          : false
                      "
                      block
                      :size="
                        this.$vuetify.display.mdAndUp ? 'x-large' : 'default'
                      "
                      class="text-uppercase ls-0 body pb-1 mt-2 px-1 rounded-0"
                      tile
                      color="primary"
                      @click="updateToCart()"
                      >UPDATE CART</v-btn
                    >
                  </v-col>
                </v-row>
              </v-row>
            </v-col>
            <!-- <v-col
              cols="12"
              class="mt-auto pb-0 d-sm-none d-block"
              v-if="projectDetails"
            >
              <p class=" ">
                {{ projectDetails.version }}
              </p>
            </v-col> -->
          </v-row>
        </v-col>
        <!-- <v-row class="mt-sm-0 mt-8" ref="bottomDivTotal"> -->
        <!-- <v-col
            cols="6"
            md="7"
            class="mt-auto pb-0 d-sm-block d-none"
            v-if="projectDetails"
          >
            <p class=" ">
              {{ projectDetails.version }}
            </p>
          </v-col> -->

        <!-- <v-col
            cols="6"
            md="7"
            class="mt-auto pb-0 d-sm-none d-block"
            v-if="projectDetails"
          >
            <p class=" ">
              {{ projectDetails.version }}
            </p>
          </v-col> -->
        <!-- </v-row> -->
      </v-row>
    </v-container>
    <!-- this component contains  session name, sign in, sign up modals  -->
    <SaveForLaterModals
      v-if="dialog"
      :saveForLaterModel="dialog"
      :subTotal="subTotal"
      @closeSaveForLaterModal="closeSaveForLaterModal"
    />
    <!-- sign in popup -->
    <v-dialog v-model="signInForm" persistent flat max-width="500">
      <v-card flat>
        <v-card-title class="d-flex justify-space-between">
          <p class="h3 mb-0 whyte-regular-font">Sign In</p>
          <v-btn
            @click="closeSignInForm()"
            density="comfortable"
            variant="text"
            :ripple="false"
            icon
          >
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-0">
          <v-alert class="word-break" type="error" v-if="!!errorMessage">{{
            errorMessage
          }}</v-alert>
          <v-alert class="word-break" type="success" v-if="!!signInMessage">{{
            signInMessage
          }}</v-alert>
          <v-form ref="loginForm" v-model="validLogin">
            <v-col class="pt-3 pb-1">
              <v-text-field
                v-model="emailLogin"
                type="email"
                label="Email Address"
                ref="email"
                name="email"
                variant="outlined"
                density="comfortable"
                :rules="commonValidationRules.requiredRules"
              ></v-text-field>
            </v-col>
            <v-col class="pt-1 pb-0">
              <v-text-field
                v-model="passwordLogin"
                label="Password"
                ref="password"
                type="password"
                name="password"
                variant="outlined"
                density="comfortable"
                :rules="commonValidationRules.requiredRules"
              ></v-text-field>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" class="px-7">
              <v-btn
                variant="flat"
                block
                color="primary"
                class="text-white"
                @click="signIn()"
              >
                <v-progress-circular
                  :size="20"
                  color="white"
                  indeterminate
                  v-if="inProgressSignIn || inProgress"
                ></v-progress-circular>
                &nbsp;SIGN IN
              </v-btn>
            </v-col>
            <v-col cols="6" class="py-5 pl-7" align="left">
              <span
                class="text-decoration-none cursor-pointer text-primary"
                @click="openSignUpDialog()"
                >Sign Up</span
              >
            </v-col>
            <v-col cols="6" class="py-5 pr-7" align="right"> </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Sign Up -->
    <v-dialog v-model="signUpForm" persistent flat max-width="500">
      <v-card flat>
        <v-card-title class="d-flex justify-space-between">
          <p class="h3 mb-0 whyte-regular-font">Sign Up</p>
          <v-btn
            @click="closeSignUpForm()"
            density="comfortable"
            variant="text"
            :ripple="false"
            icon
          >
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-0">
          <v-alert class="word-break" type="error" v-if="!!errorUpMessage">{{
            errorUpMessage
          }}</v-alert>
          <v-alert class="word-break" type="success" v-if="!!signUpMessage">{{
            signUpMessage
          }}</v-alert>
          <v-form ref="signUpForm" id="signup-form" @submit.prevent="signUp">
            <v-text-field
              class="pt-2"
              label="First Name"
              type="text"
              ref="firstName"
              name="firstName"
              variant="outlined"
              density="comfortable"
              v-model="firstname"
              :rules="firstNameRules"
            ></v-text-field>
            <v-text-field
              class="pt-2"
              label="Last Name"
              type="text"
              ref="lastName"
              name="lastName"
              variant="outlined"
              density="comfortable"
              v-model="lastname"
              :rules="lastNameRules"
            ></v-text-field>

            <v-text-field
              class="pt-2"
              label="Email Id"
              type="email"
              ref="email"
              name="email"
              id="userEmail"
              variant="outlined"
              density="comfortable"
              v-model="email"
              :rules="signUpEmailRules"
            ></v-text-field>

            <v-text-field
              class="pt-2 mt-0"
              type="password"
              label="Password"
              ref="password"
              name="password"
              variant="outlined"
              density="comfortable"
              v-model="password"
              :rules="commonValidationRules.passwordRule"
            ></v-text-field>
            <v-checkbox
              v-model="newsletter"
              label="Subscribe to our newsletter"
              hide-details="true"
              color="indigo"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" class="px-7">
              <v-btn
                variant="flat"
                block
                color="primary"
                class="text-white"
                @click="signUp(product)"
              >
                <v-progress-circular
                  :size="20"
                  color="white"
                  indeterminate
                  v-if="inProgressSignUp || inProgress || localSignUpLoader"
                ></v-progress-circular>
                &nbsp;SIGN UP
              </v-btn>
            </v-col>
            <v-col cols="6" class="py-5 pl-7" align="left">
              <span
                class="text-decoration-none cursor-pointer text-primary"
                @click="openSignInDialog()"
                >Sign In</span
              >
            </v-col>
            <v-col cols="6" class="py-5 pr-7" align="right"> </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showPrintProcessAlertDialog"
      origin="left top"
      hide-overlay
      persistent
      max-width="650px"
    >
      <v-card flat class="pa-6">
        <v-card-text class="d-flex align-center text-error pa-0 py-2">
          <v-icon class="header-action-icons mr-2" size="24"
            >mdi-alert-circle-outline</v-icon
          >
          <span v-html="printProcessWarningMessage" class="body"> </span>
        </v-card-text>
        <v-card-actions class="pa-0 py-2">
          <v-row no-gutters>
            <v-col cols="12" class="pa-0">
              <v-btn
                variant="flat"
                color="primary"
                class="text-white float-right"
                @click="showPrintProcessAlertDialog = false"
              >
                Understood
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/*eslint-disable*/
import { loginInterrupt } from "@/services/nav";
import { createHelpers } from "vuex-map-fields";
import redoInactive from "@/assets/redo-inactive.png";
import redoActive from "@/assets/redo-active.png";
import undoActive from "@/assets/undo-active.png";
import undoInactive from "@/assets/undo-inactive.png";
import ProductPageHeader from "@/components/layout/header/ProductPageHeader.vue";
import SaveForLaterModals from "@/components/session/SaveForLaterModals.vue";

import {
  getLable,
  googleAanalytics,
  priceFormatter,
  checkPromotion,
  getSessionItemProcessesAndLiner,
  handleBeforeUnload,
  // customAttributeValue,
  commonValidationRules,
  // googleAanalyticsEventSaveForLatter,
  isoStringToNormalDate,
  surfaceIds,
  getCurrentItemDeltaStructure,
  sendAppcuesEvent,
  processDateWarningDetails,
  getFinalPrice,
  getCurrentItemStructure,
  getSessionItemCombinedElements,
  getFirstColorElement,
  assignColorAndPrint,
  getElementWithHighestColorAddon,
  ensurePrintableElements,
  getAllPrintableElements
} from "@/services/util.service";
// import { getPartPricByStructure } from "@/services/getSessionItemsPricerObject.service.js";
const { mapFields: mapProductPartsFields } = createHelpers({
  getterType: "productPartList/getField",
  mutationType: "productPartList/updateField",
});
const craneShopUrl = import.meta.env.VITE_APP_CRANE_DAILY_URL;
const craneSessionTimer = import.meta.env.VITE_APP_CRANE_SESSION_TIMER;

import craneLogoBlue from "@/assets/Crane_Logo_blue.png";
import craneLogoWhite from "@/assets/Crane_Logo_white.png";

import {
  pricerFieldsIdx,
  pricerFiles,
  priceProduct,
} from "@cranestationery/crane-pricer";
import { isElement } from "lodash";

const { mapFields: mapFieldsAuth } = createHelpers({
  getterType: "auth/getField",
  mutationType: "auth/updateField",
});
const { mapFields: registerInfo } = createHelpers({
  getterType: "registration/getField",
  mutationType: "registration/updateField",
});

export default {
  name: "ProductSummaryComponent",
  props: ["productSummary"],
  components: {
    ProductPageHeader,
    SaveForLaterModals,
  },
  data: () => ({
    designWindowHeight: 0,
    commonValidationRules,
    surfaceIds,
    redoInactive,
    redoActive,
    undoActive,
    undoInactive,
    priceFormatter,
    index: 0,
    right: true,
    dialog: false,
    showMenu: false,
    productSummaryDetails: [],
    userSelectedParts: [],
    subTotal: 0,
    productQuantity: 0,
    imagePanelHeight: 0,
    isPageLoader: false,
    defaultUrl:
      "https://s3.amazonaws.com/cdn.crane.com/stg-images/cc12011-1_360.webp",
    disableSubmit: true,
    isErrorInPrice: false,
    qtyPriceArray: [],
    selectedIndex: null,
    processingTime: null,
    builderItems: [],
    printProcessMismatched: false,
    printProcessGranted: false,
    isPromotionApplied: false,
    productPrice: 0,
    acceptAndApproved: false,
    productParts: [],
    priceAdjustmentType: null,
    priceAdjustmentValue: null,
    craneLogoBlue: craneLogoBlue,
    craneLogoWhite: craneLogoWhite,
    productSku: null,
    itemId: null,
    cartId: null,
    userQuantity: null,
    summaryDetails: null,
    customAttributesOfCurrentProduct: null,

    currentSessionItemsIds: [],
    originalSubTotal: 0,
    appliedPromotion: null,
    thumbnailInProgress: false,
    summaryDetailsInProgress: false,
    thumbnailDivHeight: 0,

    signUpForm: false,
    signInForm: false,
    valid: true,
    validLogin: false,
    firstNameRules: [
      (v) => !!v || "First Name is required",
      (v) => (v && v.length >= 3) || "First Name must be at least 3 characters",
    ],
    lastNameRules: [
      (v) => !!v || "Last Name is required",
      (v) => (v && v.length >= 3) || "Last Name must be at least 3 characters",
    ],
    signUpEmailRules: [
      (v) => !!v || "Email Id is required",
      (v) => /.+@.+\..+/.test(v) || "Email Id must be valid",
    ],
    localSignUpLoader: false,
    showPrintProcessAlertDialog: false,
    printProcessWarningMessage: null,
  }),
  computed: {
    ...mapFieldsAuth({
      oneLogin: "one",
      emailLogin: "one.email",
      passwordLogin: "one.password",
      errorMessage: "errorMessage",
      inProgressSignIn: "inProgress",
      signInMessage: "signInMessage",
    }),
    ...registerInfo({
      one: "one",
      firstname: "one.firstname",
      lastname: "one.lastname",
      newsletter: "one.newsletter",
      email: "one.email",
      password: "one.password",
      inProgressSignUp: "one.inProgress",
      signUpMessage: "signUpMessage",
      errorUpMessage: "errorMessage",
    }),
    projectDetails: function () {
      return this.$store.state.layout.product;
    },
    builderSessionId: function () {
      return this.$route.params.sessionId;
    },
    builderSessionItems: function () {
      return this.$store.state.sessionItemList.list;
    },
    // user selected session items for builder
    // userSelectedSessionItems: function () {
    //   return this.$store.state.sessionItemList.userSelectedSessionItems;
    // },

    // magento v1 product details
    sessionProductDetails: function () {
      return this.$store.state.productOne.sessionProductDetails;
    },
    // builder session details
    sessionOneDetails: function () {
      return this.$store.state.sessionOne.one;
    },
    categoryId: function () {
      return this.$route.query.categoryId;
    },
    designerFlag: function () {
      return this.$route.params.designerMode;
    },
    cartItemEdit: function () {
      if (this.cartId) return true;
      return false;
    },
    isMobileDevice() {
      return this.$vuetify.display.xs ? true : false;
    },
    productOne: function () {
      return this.$store.state.designerOne.one;
    },
    productDetails: function () {
      return this.$store.state.productOne.productDetails;
    },
    userAuth: function () {
      return this.$store.state.auth.userAuth;
    },
    userId: function () {
      if (this.userAuth && this.$store.state.accountOne.one)
        return this.$store.state.accountOne.one.id;
      return "";
    },
    categoryListIdWise: function () {
      return this.$store.state.headerCategoryList.categoryList;
    },
    basicInfo() {
      return this.$store.state.accountOne.one;
    },
    productPricerDataset: function () {
      return this.$store.state.productOne.productPricerDataset;
    },
    cartItems() {
      if (this.userAuth) {
        return this.$store.state.userCartProduct.cartProductList;
      } else {
        return this.$store.state.cartProduct.cartProductList;
      }
    },
    ...mapProductPartsFields(["list", "inProgress"]),
  },
  watch: {
    productDetails() {
      this.fetchQuantiyArray();
    },
    // userSelectedSessionItems:{
    //   immediate: true,
    //   async handler(){
    //     this.currentSessionItemsIds = []
    //     let ids = []
    //     this.userSelectedSessionItems.filter((obj => ids.push(obj.id)))
    //     this.currentSessionItemsIds = ids
    //   }
    // },
  },
  methods: {
    getCurrentPartSurface(id) {
      if (this.surfaceIds)
        return this.surfaceIds.filter((surface) => surface.id == id)[0]?.name;
      return "";
    },
    builderSession(product) {
      let builderSessionOne = null;
      if (
        product &&
        product.options &&
        product.options.options &&
        product.options.options.length > 0
      ) {
        let optionsList = product.options.options;
        builderSessionOne = optionsList.find(
          (x) => x && x.label && x.label.toLowerCase() == "buildersessionid"
        );

        if (builderSessionOne) {
          return true;
        }
      }
      return false;
    },
    getProductCustomOptions() {
      let sessionProductItemOptions =
        this.sessionProductDetails &&
        this.sessionProductDetails.items &&
        this.sessionProductDetails.items.length &&
        this.sessionProductDetails.items[0].options
          ? this.sessionProductDetails.items[0].options
          : null;
      let productCustomOptions = [];
      if (sessionProductItemOptions) {
        for (let i = 0; i < sessionProductItemOptions.length; i++) {
          let currentOption = sessionProductItemOptions[i];
          if (
            currentOption.title &&
            currentOption.title.toLowerCase() == "buildersessionid"
          ) {
            productCustomOptions.push({
              option_id: currentOption.optionId,
              option_value: this.builderSessionId,
            });
          }
        }
      }
      return productCustomOptions;
    },
    async addSaveForLater() {
      this.dialog = true;
      await this.$store.dispatch("sessionOne/updateOne", {
        sessionId: this.builderSessionId,
        property: {
          productData: {
            ...this.sessionOneDetails.productData,
            quantity: this.productQuantity,
          },
          summaryTs: new Date().toISOString(),
        },
      });
    },
    closeSaveForLaterModal() {
      this.dialog = false;
    },
    // async updateQtyInSessionDetails() {
    //   try {
    //     await this.$store.dispatch("sessionOne/updateOne", {
    //       sessionId: this.builderSessionId,
    //       property: {
    //         productData: {
    //           ...this.sessionOneDetails.productData,
    //           quantity: this.productQuantity,
    //           productSubTotal: this.subTotal,
    //         },
    //         quoteData: {
    //           ...this.sessionOneDetails.quoteData,
    //           // quantity: this.productQuantity,
    //           productSubTotal: this.subTotal,
    //         },
    //       },
    //     });
    //     await this.fetchSessionAndItems();
    //   } catch (e) {
    //     console.error("Error in updating quantity in session ", e);
    //     throw e;
    //   }
    // },
    checkAcceptAndApproved() {
      if (this.acceptAndApproved) this.acceptAndApproved = true;
      else this.acceptAndApproved = false;
    },
    resize() {
      let divRef = this.$refs.bottomDivTotal;
      let height = divRef.$el.clientHeight + 80;
      this.designWindowHeight = window.innerHeight - height;
      this.thumbnailDivHeight = window.innerHeight - 130;
      let headerHeight = 56;
      this.imagePanelHeight = window.innerHeight - (headerHeight + 100);
    },
    closeSheet(value) {
      this.$store.dispatch("productOne/summarySheet", value);
    },
    fetchQuantiyArray() {
      try {
        let list = this.getCustomAttributeLable(
          this.productDetails.customAttribute,
          "qty_price"
        )
          ? JSON.parse(
              this.getCustomAttributeLable(
                this.productDetails.customAttribute,
                "qty_price"
              )
            )
          : [];
        this.qtyPriceArray = list;
        if (this.qtyPriceArray.length) this.setQuantity();
      } catch (e) {
        console.error(e);
      }
    },
    getCustomAttributeLable(customAttributes, attributeCode) {
      if (customAttributes) return getLable(customAttributes, attributeCode);
    },
    setQuantity() {
      if (this.productQuantity) {
        for (let i = 0; i < this.qtyPriceArray.length; i++) {
          let obj = this.qtyPriceArray[i];
          if (Number(obj.qty) == this.productQuantity) {
            this.selectedIndex = i;
            break;
          }
        }
        this.productQuantity = this.qtyPriceArray[this.selectedIndex]
          ? Number(this.qtyPriceArray[this.selectedIndex].qty)
          : Number(this.qtyPriceArray[0].qty);
        // this.productPrice = this.qtyPriceArray[this.selectedIndex]
        //   ? Number(this.qtyPriceArray[this.selectedIndex].price)
        //   : Number(this.qtyPriceArray[0].price);
      }
    },
    async changeQuantity(index) {
      if (index >= 0 && index < this.qtyPriceArray.length) {
        //this.$snotify.clear()
        this.selectedIndex = index;
        this.productQuantity = Number(
          this.qtyPriceArray[this.selectedIndex].qty
        );
        localStorage.setItem(
          `cr_${this.builderSessionId}`,
          JSON.stringify({ qty: this.productQuantity })
        );
        // this.productPrice = this.qtyPriceArray[this.selectedIndex].price;
        if (!this.isPromotionApplied) {
          // console.log(`Please wait while we fetch price details`)
          this.$snotify.warning(`Please wait while we fetch price details`, {
            position: "rightTop",
            showProgressBar: false,
          });
        }
        await this.productPromotionCheck();
        await this.getCurrentPartDeltaStructure();
      } else {
        this.$snotify.warning(`Quantity is not available`, {
          position: "rightTop",
          showProgressBar: false,
        });
      }
    },
    getSessionItemThumbnails() {
      try {
        this.productParts = [];
        for (let p = 0; p < this.builderSessionItems.length; p++) {
          let sessionItemOneDetails = this.builderSessionItems[p];
          let secondPartSessionItem = this.builderSessionItems.filter(
            (item) =>
              item.isSelected &&
              item.productPartId == sessionItemOneDetails.productPartId &&
              item.surfaceType == "alternateSurface"
          );

          let sessionItem = {
            thumbnailUrl: sessionItemOneDetails.thumbnailUrl,
            thumbnailUrls: [
              {
                thumbnailUrl: sessionItemOneDetails.thumbnailUrl,
                surface: sessionItemOneDetails.surface,
                id: sessionItemOneDetails.id,
              },
            ],
            partSelected: sessionItemOneDetails.isSelected,
            partModified: sessionItemOneDetails.isSelected,
            name: sessionItemOneDetails.summaryData.defaultStructure.name,
            id: sessionItemOneDetails.id,
            userSelected: sessionItemOneDetails.isSelected,
          };

          if (secondPartSessionItem && secondPartSessionItem.length) {
            let itm = secondPartSessionItem[0];
            sessionItem.thumbnailUrls.push({
              thumbnailUrl: itm.thumbnailUrl,
              surface: itm.surface,
              id: itm.id,
            });
            p++; // to skip alternate surface session item
          }

          this.productParts.push(sessionItem);
        }
      } catch (err) {
        throw err;
      } finally {
        this.thumbnailInProgress = false;
      }
    },
    async getCurrentPartDeltaStructure() {
      try {
        this.summaryDetailsInProgress = true;
        this.originalSubTotal = 0;
        this.addonPrice = 0;
        this.productSummaryDetails = [];
        this.disableSubmit = true;
        let partHasIssue = false;
        this.currentSessionItemsIds = [];
        // let productElements = { currentElements: [], defaultElements: [] };

        let basePrice = 0;

        const pricerType = "cloud";
        const pricerOptions = {
          pricingDateTime: Date.now(),
          fallbackToOMS: false,
          compareToOMS: false,
          audit: [],
        };

        let allElements = getSessionItemCombinedElements({
          items: this.builderSessionItems,
        });

        // let allPrintableElements = ensurePrintableElements({
        //   elements: allElements,
        //   defaultElements: this.builderSessionItems.flatMap(
        //     (item) => item?.summaryData?.defaultStructure?.elements || []
        //   ),
        // });

        // if (allPrintableElements.length == 0) {
        //   const firstWithPrint = allElements.find((el) => el?.print != null);
        //   if (firstWithPrint) {
        //     const firstDefaultWithPrint = this.builderSessionItems
        //       .flatMap(
        //         (item) => item?.summaryData?.defaultStructure?.elements || []
        //       )
        //       .find((el) => el?.name === firstWithPrint?.name);
        //     if (firstDefaultWithPrint)
        //       allPrintableElements.push({
        //         ...firstDefaultWithPrint,
        //         isOptional: null,
        //         removed: false,
        //       });
        //   }
        // }
        let elementWithHighestColorAddon = getElementWithHighestColorAddon({
          elements: allElements,
        });
        console.log(
          "elementWithHighestColorAddon",
          elementWithHighestColorAddon
        );

        // let foundFirstNonEnvelope = false;
        const firstColorElement =
          getFirstColorElement({ elements: allElements }) || {};

        // const isEnvelopeOnly =
        //   Array.isArray(this.builderSessionItems) &&
        //   this.builderSessionItems.length === 1 &&
        //   this.builderSessionItems[0]?.summaryData?.defaultStructure?.name
        //     ?.toLowerCase()
        //     ?.includes("envelope");

        // if (isEnvelopeOnly) {
        //   let sessionItemOneDetails = this.builderSessionItems[0];
        //   let structure = {
        //     ...sessionItemOneDetails?.summaryData?.currentStructure,
        //     elements: [...(allPrintableElements || [])],
        //   };

        //   let maximalStructure = assignColorAndPrint({
        //     structure,
        //     print: elementWithHighestColorAddon?.print?.name,
        //     color: firstColorElement.color,
        //   });

        //   console.log("maximalStructure", maximalStructure);

        //   //  allElements = maximalStructure.elements;

        //   const productConfiguration = {
        //     configuredStructure: maximalStructure,
        //     qty: this.productQuantity,
        //   };

        //   let pricerResponse = await priceProduct({
        //     pricer: pricerType,
        //     productConfiguration,
        //     options: pricerOptions,
        //   });
        //   console.log("pricerResponse", pricerResponse);
        //   if (pricerResponse?.errors?.length > 0) {
        //     throw new Error("Error getting price, please contact support team");
        //   }

        //   basePrice += Number(pricerResponse?.currentCloudPrice) || 0;

        //   this.currentSessionItemsIds.push(sessionItemOneDetails.id);
        //   let combinedElements = {
        //     [sessionItemOneDetails.surface]: {
        //       itemId: sessionItemOneDetails.id,

        //       elements:
        //         sessionItemOneDetails.summaryData.currentStructure.elements,
        //     },
        //   };
        //   this.productSummaryDetails.push({
        //     ...sessionItemOneDetails.summaryData.currentStructure,
        //     name: sessionItemOneDetails.summaryData.defaultStructure.name,
        //     paperWidth:
        //       sessionItemOneDetails.summaryData.currentStructure.paperWidth,
        //     paperHeight:
        //       sessionItemOneDetails.summaryData.currentStructure.paperHeight,
        //     combinedElements,
        //     id: sessionItemOneDetails.id,
        //   });
        // } else {
        for (let p = 0; p < this.builderSessionItems.length; p++) {
          let sessionItemOneDetails = this.builderSessionItems[p];

          this.currentSessionItemsIds.push(sessionItemOneDetails.id);
          let combinedElements = {};
          let currentPartSurfaceType = sessionItemOneDetails.surfaceType;
          let isAlteranteSurface =
            currentPartSurfaceType == "alternateSurface" || false;

          let secondPartSessionItem = this.builderSessionItems.filter(
            (item) =>
              item.isSelected &&
              item.productPartId == sessionItemOneDetails.productPartId &&
              item.surfaceType !== currentPartSurfaceType
          );

          let itemResp = null;
          if (secondPartSessionItem && secondPartSessionItem.length) {
            itemResp = secondPartSessionItem[0];
          }

          if (sessionItemOneDetails.isSelected) {
            if (isAlteranteSurface) {
              combinedElements = {
                [itemResp.surface]: {
                  itemId: itemResp.id,

                  elements: itemResp.summaryData.currentStructure.elements,
                },
                [sessionItemOneDetails.surface]: {
                  itemId: sessionItemOneDetails.id,

                  elements:
                    sessionItemOneDetails.summaryData.currentStructure.elements,
                },
              };
            } else {
              combinedElements = {
                [sessionItemOneDetails.surface]: {
                  itemId: sessionItemOneDetails.id,

                  elements:
                    sessionItemOneDetails.summaryData.currentStructure.elements,
                },
              };
              if (itemResp && itemResp.summaryData) {
                combinedElements = {
                  ...combinedElements,
                  [itemResp.surface]: {
                    elements: itemResp.summaryData.currentStructure.elements,
                    itemId: itemResp.id,
                  },
                };
              }
            }

            if (!isAlteranteSurface) {
              this.productSummaryDetails.push({
                ...sessionItemOneDetails.summaryData.currentStructure,
                name: sessionItemOneDetails.summaryData.defaultStructure.name,
                paperWidth:
                  sessionItemOneDetails.summaryData.currentStructure.paperWidth,
                paperHeight:
                  sessionItemOneDetails.summaryData.currentStructure
                    .paperHeight,
                combinedElements,
                id: sessionItemOneDetails.id,
              });

              let structure = await getCurrentItemStructure(
                sessionItemOneDetails,
                this.builderSessionItems
              );

              // Check if current item is an envelope
              // const isEnvelope =
              //   sessionItemOneDetails?.summaryData?.defaultStructure?.name
              //     ?.toLowerCase()
              //     ?.includes("envelope");

              let maximalStructure;

              // if (isEnvelope) {
              //   // ❌ Envelope → always remove elements
              //   maximalStructure = {
              //     ...structure,
              //     elements: [],
              //   };
              // } else if (!foundFirstNonEnvelope) {
              // ✅ First non-envelope → keep elements & assign color/print
              //foundFirstNonEnvelope = true;

              let allPrintableElements = structure.elements
                .filter(
                  (currentEle) =>
                    currentEle.type !== "liner" && currentEle.type !== "paper"
                )
                .map((currentEle) => ({
                  ...currentEle,
                  isOptional: null,
                  removed: false,
                }));
              maximalStructure = assignColorAndPrint({
                structure: {
                  ...structure,
                  elements: allPrintableElements,
                },
                print: elementWithHighestColorAddon?.print?.name,
                color: firstColorElement.color,
              });
              // } else {
              //   // ❌ Remaining non-envelope items → remove elements
              //   maximalStructure = {
              //     ...structure,
              //     elements: [],
              //   };
              // }

              console.log("maximalStructure", maximalStructure);

              const productConfiguration = {
                configuredStructure: maximalStructure,
                qty: this.productQuantity,
              };

              let pricerResponse = await priceProduct({
                pricer: pricerType,
                productConfiguration,
                options: pricerOptions,
              });

              if (pricerResponse?.errors?.length > 0) {
                throw new Error(
                  "Error getting price, please contact support team"
                );
              }

              basePrice += Number(pricerResponse?.currentCloudPrice) || 0;
            }
          }
        }

        let allValidPrintableElements = getAllPrintableElements({
          elements: allElements,
        });
        let getFinalPriceResponse = getFinalPrice({
          elements: allValidPrintableElements,
          basePrice: basePrice,
        });
        console.log("getFinalPriceResponse", getFinalPriceResponse);

        this.originalSubTotal = getFinalPriceResponse.price;
        this.addonPrice = getFinalPriceResponse.addonPrice;

        if (partHasIssue) {
          this.disableSubmit = true;
        } else {
          this.disableSubmit = false;
          this.isErrorInPrice = false;
        }
        if (!this.isPromotionApplied) {
          this.subTotal = this.originalSubTotal;
          this.callsendAppcuesEvent(this.subTotal);
        }
        if (
          this.priceAdjustmentType &&
          this.priceAdjustmentType == "discount_percentage"
        ) {
          this.subTotal = this.originalSubTotal;
          if (Number(this.priceAdjustmentValue)) {
            this.subTotal =
              this.subTotal * (1 - Number(this.priceAdjustmentValue) / 100);
            this.callsendAppcuesEvent(this.subTotal);
          }
        }
      } catch (err) {
        console.error("Error while changing quantity ", err);
        this.disableSubmit = true;
        this.isErrorInPrice = true;
      } finally {
        this.summaryDetailsInProgress = false;
      }
    },
    menuAction: function () {
      this.$emit("action", { showMenu: !this.showMenu });
    },
    async backToEditPart() {
      this.inProgress = true;
      await this.$store.dispatch("sessionOne/updateOne", {
        sessionId: this.builderSessionId,
        property: {
          productData: {
            ...this.sessionOneDetails.productData,
            quantity: this.productQuantity,
          },
          summaryTs: new Date().toISOString(),
        },
      });

      setTimeout(() => {
        this.inProgress = false;
        this.goToRoute();
      }, 500);
    },
    async addToCart() {
      try {
        let resp = this.checkIsValidSession();
        if (resp) {
          //this.$snotify.clear()
          let vm = this;
          this.inProgress = true;
          this.$snotify.warning(
            `Please wait while product gets added in cart`,
            {
              position: "rightTop",
              showProgressBar: false,
            }
          );
          let cartResponse = "";
          let productCustomOptions = this.getProductCustomOptions();
          if (this.userAuth) {
            cartResponse = await this.$store.dispatch(
              "userCartProduct/addSessionProductToCart",
              {
                sku: this.productSku,
                qty: this.productQuantity,
                price: this.subTotal,
                productOption: {
                  extension_attributes: {
                    custom_options: productCustomOptions,
                  },
                },
              }
            );
            if (cartResponse) {
              // when clicked on add to cart then and only then update summary
              for (let p = 0; p < this.builderSessionItems.length; p++) {
                await this.$store.dispatch("sessionItemOne/updateItem", {
                  sessionItemId: this.builderSessionItems[p].id,
                  property: {
                    summaryData: this.builderSessionItems[p].summaryData,
                  },
                });
                // await this.$store.dispatch("sessionItemList/updateSessionItems", {
                //   sessionItems: this.builderSessionItems,
                // });
              }

              let { qty, price } = cartResponse;

              await this.$store.dispatch("sessionOne/updateOne", {
                sessionId: this.builderSessionId,
                property: {
                  productData: {
                    ...this.sessionOneDetails.productData,
                    quantity: qty,
                  },
                  quoteData: {
                    ...this.sessionOneDetails.quoteData,
                    ...cartResponse,
                  },
                  orderState: "in_cart",
                  state: "started",
                  summaryTs: new Date().toISOString(),
                },
              });
            }
          } else {
            cartResponse = await this.$store.dispatch(
              "cartProduct/addSessionProductToCart",
              {
                sku: this.productSku,
                qty: this.productQuantity,
                price: this.subTotal,
                productOption: {
                  extension_attributes: {
                    custom_options: productCustomOptions,
                  },
                },
              }
            );
            if (cartResponse) {
              // when clicked on add to cart then and only then update summary
              for (let p = 0; p < this.builderSessionItems.length; p++) {
                await this.$store.dispatch("sessionItemOne/updateItem", {
                  sessionItemId: this.builderSessionItems[p].id,
                  property: {
                    summaryData: this.builderSessionItems[p].summaryData,
                  },
                });
                // await this.$store.dispatch("sessionItemList/updateSessionItems", {
                //   sessionItems: this.builderSessionItems,
                // });
              }
              await this.$store.dispatch("sessionOne/updateOne", {
                sessionId: this.builderSessionId,
                property: {
                  productData: {
                    ...this.sessionOneDetails.productData,
                    quantity: this.productQuantity,
                  },
                  quoteData: {
                    ...this.sessionOneDetails.quoteData,
                    ...cartResponse,
                  },
                  orderState: "in_cart",
                  state: "started",
                  summaryTs: new Date().toISOString(),
                },
              });
            }
          }
          if (window) {
            window.DD_RUM.onReady(function () {
              window.DD_RUM.addAction("studio_session", {
                session_id: vm.builderSessionId,
                session_state: "add_to_cart",
                price: vm.subTotal,
                sku: vm.productSku,
              });
            });
            // window.DD_RUM.onReady(function () {
            //   window.DD_RUM.setUser({
            //     builderSessionId: vm.builderSessionId,
            //     builderSessionState: "in_cart"
            //   });
            // });
          }
          googleAanalytics(
            cartResponse,
            this.productDetails,
            this.productQuantity,
            "add_to_cart",
            "Ecommerce",
            this.categoryListIdWise
          );
          localStorage.removeItem(`cr_${this.builderSessionId}`);
          localStorage.removeItem(`${craneSessionTimer}`);
          this.inProgress = false;
          this.$snotify.warning(`Item added in cart successfully`, {
            position: "rightTop",
            showProgressBar: false,
          });
          window.open(`${craneShopUrl}/cart-products`, "_self");
        }
      } catch (err) {
        this.$snotify.error("Error while adding product to cart", {
          position: "rightTop",
          showProgressBar: false,
        });
        this.inProgress = false;
        this.saveIncident({
          errorObject: err,
          title: "Personalize add to cart error",
          description: "Error while add to cart",
        });
        throw err;
      }
    },
    async updateToCart() {
      try {
        let resp = this.checkIsValidSession();
        if (resp) {
          let vm = this;
          this.inProgress = true;
          //this.$snotify.clear()
          this.$snotify.warning(
            `Please wait as we add this item to your cart`,
            {
              position: "rightTop",
              showProgressBar: false,
            }
          );

          let productCustomOptions = await this.getProductCustomOptions();
          let cartResponse = null;
          if (this.userAuth) {
            cartResponse = await this.$store.dispatch(
              "userCartProduct/updateSessionProductToCart",
              {
                sku: this.productSku,
                qty: this.productQuantity,
                price: this.subTotal,
                userQuote: this.getSessionItemOwner(this.sessionOneDetails),
                itemId: this.itemId,
                productOption: {
                  extension_attributes: {
                    custom_options: productCustomOptions,
                  },
                },
              }
            );
          } else {
            cartResponse = await this.$store.dispatch(
              "cartProduct/updateSessionProductToCart",
              {
                sku: this.productSku,
                qty: this.productQuantity,
                price: this.subTotal,
                itemId: this.itemId,
                productOption: {
                  extension_attributes: {
                    custom_options: productCustomOptions,
                  },
                },
              }
            );
          }
          if (cartResponse) {
            // when clicked on add to cart then and only then update summary
            for (let p = 0; p < this.builderSessionItems.length; p++) {
              await this.$store.dispatch("sessionItemOne/updateItem", {
                sessionItemId: this.builderSessionItems[p].id,
                property: {
                  summaryData: this.builderSessionItems[p].summaryData,
                },
              });
              // await this.$store.dispatch("sessionItemList/updateSessionItems", {
              //   sessionItems: this.builderSessionItems,
              // });
            }

            let { qty, price } = cartResponse;
            await this.$store.dispatch("sessionOne/updateOne", {
              sessionId: this.builderSessionId,
              property: {
                productData: {
                  ...this.sessionOneDetails.productData,
                  quantity: qty,
                },
                quoteData: {
                  ...this.sessionOneDetails.quoteData,
                  qty,
                  price,
                },
                orderState: "in_cart",
                summaryTs: new Date().toISOString(),
              },
            });

            if (window) {
              window.DD_RUM.onReady(function () {
                window.DD_RUM.addAction("studio_session", {
                  session_id: vm.builderSessionId,
                  session_state: "add_to_cart",
                  price: vm.subTotal,
                  sku: vm.productSku,
                });
              });
              // window.DD_RUM.onReady(function () {
              //   window.DD_RUM.setUser({
              //     builderSessionId: vm.builderSessionId,
              //     builderSessionState: "in_cart"
              //   });
              // });
            }
          }
          this.inProgress = false;
          localStorage.removeItem(`cr_${this.builderSessionId}`);
          localStorage.removeItem(`${craneSessionTimer}`);
          this.$snotify.warning(`Cart updated successfully`, {
            position: "rightTop",
            showProgressBar: false,
          });
          window.open(`${craneShopUrl}/cart-products`, "_self");
        }
      } catch (err) {
        this.$snotify.error("Error while updating product to cart", {
          position: "rightTop",
          showProgressBar: false,
        });
        this.inProgress = false;
        this.saveIncident({
          errorObject: err,
          title: "Personalize error while updating cart",
          description: "Error while updating cart product",
        });
        throw err;
      }
    },
    async goToSelectedElement({ type, name, id }) {
      this.inProgress = true;
      await this.$store.dispatch("sessionOne/updateOne", {
        sessionId: this.builderSessionId,
        property: {
          productData: {
            ...this.sessionOneDetails.productData,
            quantity: this.productQuantity,
          },
          summaryTs: new Date().toISOString(),
        },
      });

      setTimeout(() => {
        this.inProgress = false;
        if (this.designerMode) {
          this.$router.push({
            name: "PersonalizeSession",
            params: {
              sessionId: this.builderSessionId,
              sessionItemId: id,
              designerMode: this.designerMode,
            },
            query: {
              selectedElement: type || name,
            },
          });
        } else {
          this.$router.push({
            name: "PersonalizeSession",
            params: {
              sessionId: this.builderSessionId,
              sessionItemId: id,
            },
            query: {
              selectedElement: type || name,
            },
          });
        }
      }, 500);
    },
    goToRoute(itemId) {
      if (this.designerMode) {
        this.$router.push({
          name: "PersonalizeSession",
          params: {
            sessionId: this.builderSessionId,
            sessionItemId: itemId || this.currentSessionItemsIds[0],
            designerMode: this.designerMode,
          },
        });
      } else {
        this.$router.push({
          name: "PersonalizeSession",
          params: {
            sessionId: this.builderSessionId,
            sessionItemId: itemId || this.currentSessionItemsIds[0],
          },
        });
      }
      // }
    },
    // goToLogin() {
    //   window.open(`${craneShopUrl}/gate/sign-in`, "_self");
    // },
    goToDashboard() {
      localStorage.removeItem(`${craneSessionTimer}`);
      window.open(`${craneShopUrl}/me/account-dashboard`, "_self");
    },
    goToLogout() {
      this.$store.dispatch("auth/logout");
      localStorage.removeItem("cr_checkOutTab");
    },
    goToHomePage() {
      localStorage.removeItem(`${craneSessionTimer}`);
      window.open(`${craneShopUrl}/`, "_self");
    },
    checkMismatchPrintProcess() {
      try {
        if (!this.printProcessGranted) {
          let allPrints = [];
          if (this.productSummaryDetails) {
            for (let i = 0; i < this.productSummaryDetails.length; i++) {
              let part = this.productSummaryDetails[i];
              let combinedElements = [];
              Object.values(part.combinedElements).forEach((val) => {
                if (val.elements && val.elements.length)
                  combinedElements.push(...val.elements);
              });
              for (let e = 0; e < combinedElements.length; e++) {
                let currentEle = combinedElements[e];
                if (currentEle && currentEle.print) {
                  allPrints.push(currentEle.print.name);
                }
              }
              allPrints = [...new Set(allPrints)];
            }
          }
          if (allPrints && allPrints.length > 1) {
            this.printProcessMismatched = true;
            this.disableSubmit = true;
            return false;
          } else {
            this.printProcessMismatched = false;
            return true;
          }
        } else {
          this.printProcessMismatched = true;
          this.disableSubmit = false;
          return true;
        }
      } catch (err) {
        console.error(err);
        this.$snotify.error(`Cloud communication error `, {
          position: "rightTop",
          showProgressBar: false,
        });
        this.inProgress = false;
      }
    },
    async productPromotionCheck() {
      try {
        let productPartsObjects = [];
        for (let i = 0; i < this.builderSessionItems.length; i++) {
          let productPart = this.builderSessionItems[i];
          if (productPart.isSelected) {
            let { processes, linerObject } = getSessionItemProcessesAndLiner(
              productPart.summaryData?.currentStructure
            );
            productPartsObjects[i] = {};
            productPartsObjects[i].partName =
              productPart.summaryData?.defaultStructure?.name;
            productPartsObjects[i].processes = processes;
            productPartsObjects[i].linerObject = linerObject;
          }
        }
        let response = await checkPromotion({
          sku: this.productSku,
          quantity: Number(this.productQuantity),
          product: this.productOne,
          productPartsObjects: productPartsObjects,
        });
        if (response) {
          if (response.exclusiveRules.length !== response.exclusive.length)
            response.applied = false;
          else {
            this.appliedPromotion = response;
            console.log("Applied promotions ", response);
            if (response.appliedRules.length) {
              this.isPromotionApplied = true;
              // this.productPrice = 0;
              this.subTotal = 0;

              let sortedPromotions = [];
              for (let i = 0; i < response.appliedRules.length; i++) {
                let promotion = response.appliedRules[i];
                if (promotion.price_adjustment == "fixed") {
                  sortedPromotions.unshift(promotion);
                } else {
                  sortedPromotions.push(promotion);
                }
              }
              //fixed is on top
              for (let r = 0; r < sortedPromotions.length; r++) {
                let sortedPromotion = sortedPromotions[r];
                if (sortedPromotion.price_adjustment == "fixed") {
                  this.subTotal = sortedPromotion.price_adjustment_value;
                } else if (sortedPromotion.price_adjustment == "bump_amount") {
                  this.subTotal += sortedPromotion.price_adjustment_value;
                } else if (
                  sortedPromotion.price_adjustment == "discount_percentage"
                ) {
                  this.priceAdjustmentType = "discount_percentage";
                  this.priceAdjustmentValue =
                    sortedPromotion.price_adjustment_value;
                }
              }
              if (this.subTotal == 0 && !this.priceAdjustmentType) {
                this.subTotal = this.originalSubTotal;
                this.isPromotionApplied = false;
              }
              if (this.isPromotionApplied)
                this.$snotify.success(`Promotion is applied successfully`, {
                  position: "rightTop",
                  showProgressBar: false,
                });
            } else {
              this.isPromotionApplied = false;
              this.subTotal = this.originalSubTotal;
            }
            this.callsendAppcuesEvent(this.subTotal);
          }
        }
      } catch (err) {
        console.error(err);
        this.isErrorInPrice = true;
        this.$snotify.error(
          `Cloud communication error, please start new session `,
          {
            position: "rightTop",
            showProgressBar: false,
          }
        );
        this.saveIncident({
          errorObject: err,
          title: "Personalize error while applying promotion",
          description: "Error while applying promotion on product",
        });

        throw err;
      }
    },
    async goToBuilder(itemId, userSelectedFlag) {
      if (!userSelectedFlag) {
        this.currentSessionItemsIds.push(itemId);

        await this.$store.dispatch("sessionItemOne/updateItem", {
          sessionItemId: itemId,
          property: {
            isSelected: !userSelectedFlag,
          },
        });
      }
      this.goToRoute(itemId);
      // let path = this.$route.path;
      // path = path.replace("summary", "personalize");
      // window.open(path, "_self");
    },
    getSessionItemOwner(sessionItemObj) {
      if (sessionItemObj && sessionItemObj.quoteData) {
        return sessionItemObj.quoteData.quoteId;
      }
      return null;
    },
    async saveIncident({
      errorObject,
      title,
      description,
      tags,
      toContinueSession = false,
    }) {
      try {
        await this.$store.dispatch("incidentOne/setOne");
        let userAgent = navigator;

        let currentdate = await isoStringToNormalDate();
        let newErr = null;
        if (errorObject && errorObject.stack) {
          // && errorObject.stack.new_price
          newErr = JSON.stringify(errorObject);
        } else {
          newErr = JSON.stringify(errorObject);
        }
        let currentSessionId = this.builderSessionId;
        let incidentObj = {
          title: title,
          level: "major",
          module: "studio",
          description: description,
          tags: tags && tags.length ? tags : [],
          recorded_at: currentdate,
          metadata: {
            currentSessionId,
            errorStack: JSON.stringify(errorObject.stack || errorObject),
            error: newErr,
            platform: userAgent.platform,
            appVersion: userAgent.appVersion,
            appCodeName: userAgent.appCodeName,
          },
        };
        let savedIncidentResp = await this.$store.dispatch("incidentOne/save", {
          one: incidentObj,
        });
        console.log("savedIncidentResp", savedIncidentResp);

        let ddErr = new Error(title);
        console.error(ddErr, incidentObj.metadata);
        if (!toContinueSession) this.setCorruptedSessionData();
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    async setCorruptedSessionData() {
      try {
        // await this.$store.dispatch("sessionOne/updateOne", {
        //   sessionId: this.builderSessionId,
        //   property: {
        //     state: "in_active",
        //     summaryTs: new Date().toISOString()
        //   },
        // });
        // this.$router.push({
        //   name: "SessionStart",
        //   params: {
        //     sku: this.productSku,
        //     quantity: this.productQuantity,
        //   },
        // });
      } catch (err) {
        this.isErrorInPrice = true;
        this.$snotify.error(
          `Cloud communication error, please start new session `,
          {
            position: "rightTop",
            showProgressBar: false,
          }
        );
        throw err;
      }
    },
    checkIsValidSession() {
      try {
        if (this.sessionOneDetails) {
          let sessionUserId = this.sessionOneDetails.userData
            ? this.sessionOneDetails.userData.customerId
            : null;
          let sessionUserName = this.sessionOneDetails.userData
            ? this.sessionOneDetails.userData.customerName
            : null;
          // if session has logged in user id but currently  user is logged out
          if (!this.userAuth && sessionUserId) {
            this.$snotify.error(`To continue this session, please login`, {
              position: "rightTop",
              showProgressBar: false,
            });

            // setTimeout(() => {
            this.goToLogin();
            // loginInterrupt(
            //   window.location.href,
            //   "To continue this session, please login"
            // );
            // }, 1000);
            console.log("User needs to be logged in to be continue");
            // throw "User needs to be logged in to be continue ";
            return false;
          } else if (
            this.userAuth &&
            sessionUserId &&
            this.userId !== sessionUserId
          ) {
            this.$snotify.error(
              `To continue this session, please login with ${sessionUserName} user`,
              {
                position: "rightTop",
                showProgressBar: false,
              }
            );

            // setTimeout(() => {
            this.goToLogin();
            // loginInterrupt(
            //   window.location.href,
            //   "Please login with " + sessionUserName + " user"
            // );
            // }, 1000);
            console.log(
              sessionUserName + " user needs to be logged in to be continue "
            );
            // throw (
            //   sessionUserName + " user needs to be logged in to be continue "
            // );
            return false;
          }
        }
        return true;
      } catch (err) {
        this.isErrorInPrice = true;
        throw err;
      }
    },
    async fetchSessionAndItems() {
      try {
        await this.$store.dispatch("sessionItemList/fetchItemsForSummary", {
          sessionId: this.builderSessionId,
        });

        await this.$store.dispatch("sessionOne/fetchOne", {
          sessionId: this.builderSessionId,
        });
      } catch (err) {
        this.$snotify.error(
          `Cloud communication error, please start new session `,
          {
            position: "rightTop",
            showProgressBar: false,
          }
        );
        throw err;
      }
    },
    // async getSelectedSessionItems(builderSessionId, selected){
    //   try{
    //     await this.$store.dispatch(
    //     "sessionItemList/fetchListForBuilder",
    //     {
    //       sessionId: builderSessionId,
    //       selected
    //     }
    //   );
    //   } catch (err){
    //     console.error("Error while fetching session items ")
    //   }
    // },

    // login functionality
    closeSignInForm() {
      this.signInForm = false;
      this.dialog = false;
      this.$store.dispatch("auth/changeRedirectFlag", true);
    },
    closeSignUpForm() {
      this.signUpForm = false;
      this.signInForm = false;
      this.dialog = false;
      this.$store.dispatch("auth/changeRedirectFlag", true);
    },
    goToLogin() {
      this.signInForm = true;
      // this.signUpForm = false;
      // this.dialog = false;
      // window.open(`${storeFrontUrl}/gate/sign-in`, "_self");
    },
    openSignUpDialog() {
      this.signInForm = false;
      this.dialog = false;
      this.signUpForm = true;
    },
    openSignInDialog() {
      this.signInForm = true;
      this.dialog = false;
      this.signUpForm = false;
    },
    async signIn() {
      try {
        this.cartProductsProgress = true;
        this.inProgress = true;
        const { valid } = await this.$refs.loginForm.validate();
        if (valid) {
          this.$snotify.info("Please wait for login", {
            position: "rightTop",
            showProgressBar: false,
          });
          this.$store.dispatch("auth/changeRedirectFlag", false);
          let status = await this.$store.dispatch("auth/login");
          if (status) {
            this.$store.dispatch("auth/changeRedirectFlag", true);
            await this.$store.dispatch("accountOne/basicInfo");
            await this.$store.dispatch("userCartProduct/cartProductList");
            if (this.builderSessionId) {
              if (this.basicInfo) {
                await this.$store.dispatch("sessionOne/updateOne", {
                  sessionId: this.builderSessionId,
                  property: {
                    userData: {
                      customer_id: this.basicInfo.id,
                      customer_name: this.basicInfo.firstname,
                    },
                  },
                });
              }
              this.signInForm = false;
              this.dialog = false;
            } else {
              this.signInForm = false;
              this.dialog = false;
            }
          }
        }
        this.inProgress = false;

        this.cartProductsProgress = false;
        this.inProgress = false;
      } catch (err) {
        this.cartProductsProgress = false;
        this.inProgress = false;
        console.error(err);
      }
    },
    async signUp() {
      try {
        // if (this.$refs.signUpForm.validate()) {
        const { valid } = await this.$refs.signUpForm.validate();
        if (valid) {
          this.inProgress = true;
          this.localSignUpLoader = true;
          try {
            this.$snotify.info("Please wait for registration", {
              position: "rightTop",
              showProgressBar: false,
            });
            this.$store.dispatch("auth/changeRedirectFlag", false);
            let status = await this.$store.dispatch("registration/signUp");
            if (status.registration) {
              this.$store.dispatch("auth/changeRedirectFlag", false);
              await this.$store.dispatch("accountOne/basicInfo");
              await this.$store.dispatch(
                "userCartProduct/cartProductList",
                this.builderSessionId
              );
              if (this.builderSessionId) {
                if (this.basicInfo) {
                  await this.$store.dispatch("sessionOne/updateOne", {
                    sessionId: this.builderSessionId,
                    property: {
                      userData: {
                        customer_id: this.basicInfo.id,
                        customer_name: this.basicInfo.firstname,
                      },
                    },
                  });
                }

                this.localSignUpLoader = false;
                this.signUpForm = false;
                this.signInForm = false;
                this.dialog = false;
                this.inProgress = false;
              } else {
                this.localSignUpLoader = false;
                this.signUpForm = false;
                this.signInForm = false;
                this.dialog = false;
                this.inProgress = false;
              }
            }
            this.inProgress = false;
            this.localSignUpLoader = false;
          } catch (err) {
            console.log(err);
            this.inProgress = false;
            this.localSignUpLoader = false;
          }
        }
      } catch (error) {
        this.inProgress = false;
        this.localSignUpLoader = false;
        console.error("Error occured while sign up " + error);
      }
    },
    callsendAppcuesEvent(subTotal) {
      sendAppcuesEvent("priced_sub_total", {
        nature: "personalized",
        personality: "builder",
        currency: "USD",
        price: Number(subTotal),
        sku: this.productSku,
        quantity: this.userQuantity,
      });
    },
    checShowPrintProcessWarning() {
      try {
        let allPrintsWithWarning = [];
        if (!this.productSummaryDetails) return;

        const now = new Date();
        const endDate = new Date("2025-12-25T05:01:00Z");

        for (const part of this.productSummaryDetails) {
          // collect all combined elements
          const combinedElements = Object.values(
            part.combinedElements || {}
          ).flatMap((val) => val?.elements || []);

          for (const ele of combinedElements) {
            if (!ele?.print) continue;

            const printName = ele.print.name;
            const processISO = processDateWarningDetails[printName];

            // If this print process does not have a date → skip
            if (!processISO) continue;

            const processDate = new Date(processISO);

            // Condition:
            // show alert if now > processDate AND now < = endDate
            if (now > processDate && now <= endDate) {
              if (!allPrintsWithWarning.includes(printName)) {
                allPrintsWithWarning.push(printName);
              }
            }
          }
        }
        if (allPrintsWithWarning.length > 0) {
          this.printProcessWarningMessage = `Due to production time, ${allPrintsWithWarning.join(
            ", "
          )} orders will not arrive by Christmas.`;
          this.showPrintProcessAlertDialog = true;
        }
      } catch (err) {
        console.error(err);
      }
    },
    hideElement(element) {
      const isTrue = (v) => v === true || v === "true";

      // 1️⃣ Explicitly removed → hide
      if (isTrue(element.removed)) return true;

      const isOptional = isTrue(element.isOptional);
      const isAdded = isTrue(element.isOptionalAdded);

      // 2️⃣ Optional but not added → hide
      if (isOptional && !isAdded) return true;

      // Otherwise → show
      return false;
    },
  },
  async created() {
    // this.inProgress = true;
    this.thumbnailInProgress = true;
    this.summaryDetailsInProgress = true;
    let vm = this;
    await this.fetchSessionAndItems();
    // await this.getSelectedSessionItems(this.builderSessionId);

    let localQty = null;
    let currentSessionLocalData = localStorage.getItem(
      "cr_" + this.sessionOneDetails.id
    );
    if (currentSessionLocalData) {
      currentSessionLocalData = JSON.parse(currentSessionLocalData);
      localQty = currentSessionLocalData.qty;
    }
    try {
      await this.$store.dispatch("sessionOne/updateOne", {
        sessionId: this.builderSessionId,
        property: {
          summaryTs: new Date().toISOString(),
        },
      });

      if (window) {
        window.DD_RUM.onReady(function () {
          window.DD_RUM.addAction("studio_session", {
            session_id: vm.builderSessionId,
            session_state: "summary",
            sku: vm.productSku,
          });
        });
      }

      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (this.sessionOneDetails && this.sessionOneDetails.productData) {
        this.productSku = this.sessionOneDetails.productData.sku;
        this.productId = this.sessionOneDetails.productData.productId;
        this.userQuantity = this.sessionOneDetails.productData.quantity;

        // pricer bundle loaded
        if (this.productSku) {
          let skuList = [this.productSku];
          if (this.cartItems && this.cartItems.length) {
            for (let p = 0; p < this.cartItems.length; p++) {
              let product = this.cartItems[p];
              if (product && product.options) {
                let resp = this.builderSession(product);
                if (resp) skuList.push(product.sku);
              }
            }
          }
          if (skuList.length) {
            // pricer bundle loaded
            window.pricerFieldsIdx = pricerFieldsIdx;
            let currentDateInIso = new Date().toISOString();
            let bundleResp = await this.$store.dispatch(
              "pricerBundleOne/fetchPriceBundle",
              { skuList: skuList, availableAt: currentDateInIso }
            );
            if (bundleResp) {
              window.pricer = {
                ...pricerFiles,
                ...bundleResp,
              };
            }
            console.log(window.pricer);
          }
        }
      }

      let isValidSession = false;

      isValidSession = this.sessionOneDetails.userData
        ? this.sessionOneDetails.userData.guestId ||
          this.sessionOneDetails.userData.customerId
        : null;

      if (!isValidSession || this.sessionOneDetails.orderState == "submitted") {
        if (this.sessionOneDetails.orderState == "submitted") {
          this.$snotify.error(
            `This session is already completed, please start new session`,
            {
              position: "rightTop",
              showProgressBar: false,
            }
          );
        } else if (!isValidSession) {
          this.$snotify.error(
            `This session does not have proper user data, please start new session`,
            {
              position: "rightTop",
              showProgressBar: false,
            }
          );
        }
        this.$router.push({
          name: "SessionStart",
          params: {
            sku: this.productSku,
            quantity: localQty || this.userQuantity,
          },
        });
      }
      if (this.sessionOneDetails && this.sessionOneDetails.quoteData) {
        this.itemId = this.sessionOneDetails.quoteData.itemId;
        this.cartId = this.sessionOneDetails.quoteData.quoteId;

        // if (this.sessionOneDetails.quoteData.qty)
        //   this.userQuantity = this.sessionOneDetails.quoteData.qty;
      }

      this.productQuantity = localQty
        ? localQty
        : this.userQuantity
        ? this.userQuantity
        : 0;
    } catch (error) {
      console.error(error);
      // this.inProgress = false;
      this.goToRoute();
    }
    await this.$store.dispatch("designerOne/fetchOne", this.productId);
    await this.fetchQuantiyArray();
    await this.getSessionItemThumbnails();
    await this.productPromotionCheck();
    await this.getCurrentPartDeltaStructure();
    await this.checkMismatchPrintProcess();
    this.checShowPrintProcessWarning();
    // this.inProgress = false;

    if (!this.productDetails.id) {
      let productDetail = await this.$store.dispatch(
        "productOne/fetchProductDetails",
        this.productSku
      );
      if (productDetail.error) {
        this.$snotify.error(`This product is not available`, {
          position: "rightTop",
          showProgressBar: false,
        });
      }
    }

    await this.$store.dispatch("productOne/fetchSessionProductDetails", {
      sku: this.productSku,
    });

    let userQuoteId = null;
    if (this.userAuth) {
      await this.$store.dispatch("userCartProduct/checkUserToken");
      await this.$store.dispatch("userCartProduct/cartProductList");
      userQuoteId = await this.$store.dispatch(
        "userCartProduct/fetchUserQuote"
      );
    } else {
      userQuoteId = await this.$store.dispatch("cartProduct/fetchGuestQuote");
      await this.$store.dispatch("cartProduct/cartProductList", userQuoteId);
    }

    if (this.sessionOneDetails && this.sessionOneDetails.quoteData) {
      if (this.userAuth) {
        if (Number(this.cartId) !== userQuoteId) {
          this.cartId = null;
        }
      }
    }
  },
};
</script>
<style>
.scrollable {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.overflow {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.summary-border {
  border: thin solid #2850da8a !important;
}
</style>
<style src="./ProductSummaryComponent.scss" lang="scss" scopped />
